// extracted by mini-css-extract-plugin
export default {"about_title":"AboutPreview_about_title__68zqY","about_subtitle":"AboutPreview_about_subtitle__BHfoc","about_text":"AboutPreview_about_text__euFLk"};